import React, { useState } from "react";
import styled from "styled-components";
import { breakpoints } from "../../utils/breakpoints";
import globe from "../../utils/lf30_editor_pkdicvvj_globe.json";
import Lottie from "lottie-react";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import globe2025 from "../../images/Mask group-1.png";
import box2025 from "../../images/Mask group.png";
import tv2025 from "../../images/Mask group-2.png";
import people2025 from "../../images/Mask group-3.png";
import igeniusBanner from "../../images/igtransparentwhite.png";


const StyledDiv = styled.div`
	overflow-x: hidden;
	overflow-y: hidden;
	padding: 15px 0;
	background: #0A0B0D no-repeat padding-box;
	color: white;

	


	.content-container {
		position: relative;
		display: grid;
		width: 95%;
		height: 420px;
		align-items: center;
		background-size: cover;
		background-repeat: no-repeat;
		justify-content: space-evenly;
		background-image: linear-gradient(rgba(0, 0, 0, 0.54), rgba(0, 0, 0, 0.54)));
		-webkit-mask-image: linear-gradient(to bottom, rgba(0,0,0,1) 60%, rgba(0,0,0,0) 100%);
		mask-image: linear-gradient(to bottom, rgba(0,0,0,1) 100%, rgba(0,0,0,0) 100%);
		z-index: 0;
		


		.stats {
			width: 100%;
			margin: auto;
			z-index: 1;
			display: grid;
			grid-template-columns: 1fr 1fr 1fr 1fr;
			grid-gap: 100px;
			align-items: center;
			position: absolute;
			bottom: 15%;
    		left: 0%;
			heigh: 100%;

			.stat {
				height: 100%;
				.stat-txt {
					color: white;
					font-size: 28px;
				}

				img{
					width: 40%;
				}

				.stat-num {
					font: normal normal bold 2.5vw/2.5vw Nexa-bold;
					padding-top: 25px;
					background: linear-gradient(180deg, #89D0C2 0%, #44B2DD 100%);
					font-family: "nexa-bold";
					background-clip: text;
					font-weight: 900;
					-webkit-background-clip: text;
					padding-bottom: 10px;
					-webkit-text-fill-color: transparent;
				}
			}
		}
	}

	@media screen and ${breakpoints.device.tablet} {
		padding: 10px 0;
		.content-container {
			flex-direction: column;
			height: 550px;

			.stats {
				grid-template-columns: 1fr 1fr;

				.stat {
					padding: 10px 0;

					.stat-txt {
						font-size: 3vw;
					}

					.stat-num {
						font-size: 3.5vw;
					}
				}
			}
		}
	}

	@media screen and ${breakpoints.device.mobileL} {
		.content-container {
			.stats {
				grid-gap: 50px;

				.stat {
					.stat-txt {
						font-size: 5vw;
						line-height: 7vw;
					}

					.stat-num {
						font-size: 5.5vw;
					}
				}
			}
		}
	}
`;


const StatsSection = () => {
	const [counterOn, setCounterOn] = useState(false);

	return (
		<StyledDiv>
			<div className="content-container">
				
				<ScrollTrigger
					onEnter={() => setCounterOn(!counterOn)}
					onExit={() => setCounterOn(true)}>
					<div className="stats">
						<div className="stat">
							<img src={box2025} />
							<div className="stat-num">
								{counterOn ? (
									<CountUp
										end={
											123
										}
										duration={
											2
										}
									/>
								) : (
									123
								)}
							</div>
							<div className="stat-txt">
								Countries
							</div>
							
						</div>
						<div className="stat">
							<img src={globe2025} />
								<div className="stat-num">
								{counterOn ? (
									<CountUp
										end={
											22
										}
										duration={
											2
										}
									/>
								) : (
									22
								)}
								+
							</div>
							<div className="stat-txt">
								Products
							</div>
						
						</div>
						<div className="stat">
							<img src={tv2025} />
							<div className="stat-num">
								{counterOn ? (
									<CountUp
										end={
											2500
										}
										duration={
											2
										}
									/>
								) : (
									2500
								)}
								+
							</div>
							<div className="stat-txt">
								Educational
								Videos
							</div>
							
						</div>
						<div className="stat">
							<img src={people2025} />
							<div className="stat-num">
								{counterOn ? (
									<CountUp
										end={
											85
										}
										duration={
											2
										}
									/>
								) : (
									85
								)}
								+
							</div>
							<div className="stat-txt">
								Weekly Live
								Sessions
							</div>
							
						</div>
					</div>
				</ScrollTrigger>
			</div>
		</StyledDiv>
	);
};

export default StatsSection;
